import { api } from "../../shared/api.js";
import { queryClient } from "../../shared/query.js";

/** Videoraum geladen → „Patient im Raum“ (T9, idempotent) */
export function markJoined(caseId: string) {
  void api(`/cases/${caseId}/joined`, { method: "POST" })
    .then(() => queryClient.invalidateQueries({ queryKey: ["case", caseId] }))
    .catch(() => undefined);
}
